<div
  class="layout"
  id="scrolling-container"
  hidden>
  <app-public-header class="layout_header" />
  <div class="layout_content">
    <main
      class="layout_main"
      autoscroll="true"
      ui-view></main>
  </div>
  <div class="layout_footer">
    <app-legal-terms-footer />
  </div>
</div>

<app-icons-sprite></app-icons-sprite>
